import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { FacultyRotationModel } from '../model/faculty_rotation.model';
import { TraineeRotationsModel } from '../model/trainee_rotations.model';
import { TrainerTraineeItemPendingReturnModel } from '../model/trainer_trainee_pending_item.model';
import { TrainerApproveAllModel } from '../model/trainer_approve_all.model';
import { RotationTypeModel } from '../model/rotation_type.model';
import { ApiResultModel } from '../model/api_result.model';
import { TraineeRotationScheduleModel } from '../model/trainee_rotation_schedule.model';
import { TraineeRotationScheduleCreateModel } from '../model/trainee_rotation_schedule_create.model';

import { API_URLS } from '../utils/api_url.util';
import { API_UTILS } from '../utils/api_utils.util';
import { catchError } from 'rxjs/operators';

/*
  Generated class for the UserFaculties provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class RotationsService {
	mFacultyRotation: FacultyRotationModel;

	constructor(private http: HttpClient) {}

	getTraineeRotationScheduleRotations(scheduleId: string): Observable<Array<TraineeRotationsModel>> {
		let items$ = this.http
			.get<Array<TraineeRotationsModel>>(API_URLS.API_GET_TRAINEE_ROTATION_SCHEDULE_ROTATIONS + `/${scheduleId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getItems(userId: string): Observable<Array<TraineeRotationsModel>> {
		let items$ = this.http
			.get<Array<TraineeRotationsModel>>(API_URLS.API_GET_TRAINEE_ROTATIONS + `/${userId}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getAllItems(): Observable<Array<TraineeRotationsModel>> {
		let items$ = this.http
			.get<Array<TraineeRotationsModel>>(API_URLS.API_GET_ALL_TRAINEE_ROTATIONS)
			.pipe(catchError(handleError));
		return items$;
	}

	getRotationReports(): Observable<Array<TraineeRotationsModel>> {
		let items$ = this.http
			.get<Array<TraineeRotationsModel>>(API_URLS.API_GET_TRAINEE_ROTATIONS)
			.pipe(catchError(handleError));
		return items$;
	}

	getRotationByRef(refNo: string): Observable<TraineeRotationsModel> {
		let items$ = this.http
			.get<TraineeRotationsModel>(API_URLS.API_GET_TRAINEE_ROTATION_BY_REF + `/${refNo}`)
			.pipe(catchError(handleError));
		return items$;
	}

	getRotationTypes(): Observable<Array<RotationTypeModel>> {
		let items$ = this.http
			.get<Array<RotationTypeModel>>(API_URLS.API_GET_ROTATION_TYPES)
			.pipe(catchError(handleError));
		return items$;
	}

	getFacultyRotations(facultyId: string, programCategoryId: number): Observable<Array<FacultyRotationModel>> {
		let items$ = this.http
			.get<Array<FacultyRotationModel>>(
				API_URLS.API_GET_FACULTY_ROTATION_TYPES + `/${facultyId}` + `/${programCategoryId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getTraineeRotationSchedules(
		userId: string,
		facultyRotationId: string
	): Observable<Array<TraineeRotationScheduleModel>> {
		let items$ = this.http
			.get<Array<TraineeRotationScheduleModel>>(
				API_URLS.API_GET_TRAINEE_ROTATION_SCHEDULES + `/${userId}` + `/${facultyRotationId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerTraineeRotations(trainerId: string, traineeId: string): Observable<Array<TraineeRotationsModel>> {
		let items$ = this.http
			.get<Array<TraineeRotationsModel>>(
				API_URLS.API_GET_TRAINER_TRAINEE_ROTATIONS + `/${trainerId}` + `/${traineeId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	getTrainerTraineesWithPendingRotations(trainerId: string): Observable<Array<TrainerTraineeItemPendingReturnModel>> {
		let items$ = this.http
			.get<Array<TrainerTraineeItemPendingReturnModel>>(
				API_URLS.API_GET_TRAINEER_TRAINEES_WITH_PENDING_ROTATIONS + `/${trainerId}`
			)
			.pipe(catchError(handleError));
		return items$;
	}

	approveAllTrainerTraineePendingRotaions(item: TrainerApproveAllModel): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_POST_APPROVE_TRAINER_TRAINEE_ALL_ROTATIONS, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	updateTraineeRotationSchedule(item: TraineeRotationScheduleCreateModel): Observable<ApiResultModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<ApiResultModel>(API_URLS.API_UPDATE_TRAINEE_ROTATION_SCHEDULES, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	addItem(item: TraineeRotationsModel): Observable<TraineeRotationsModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.post<TraineeRotationsModel>(API_URLS.API_POST_ADD_TRAINEE_ROTATIONS, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	editItem(item: TraineeRotationsModel): Observable<TraineeRotationsModel> {
		// item.ApprovalStatus="APPROVED";
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.post<TraineeRotationsModel>(API_URLS.API_POST_EDIT_TRAINEE_ROTATIONS, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	removeItem(item: TraineeRotationsModel): Observable<TraineeRotationsModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let id = item.Id;

		let items$ = this.http
			.get<TraineeRotationsModel>(API_URLS.API_POST_REMOVE_TRAINEE_ROTATIONS + `/${id}`)
			.pipe(catchError(handleError));
		return items$;
	}

	addFacultyRotation(item: FacultyRotationModel): Observable<FacultyRotationModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };
		let items$ = this.http
			.post<FacultyRotationModel>(API_URLS.API_FACULTY_ROTATION, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	editFacultyRotation(item: FacultyRotationModel): Observable<FacultyRotationModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.put<FacultyRotationModel>(API_URLS.API_FACULTY_ROTATION + `/${item.Id}`, body, options)
			.pipe(catchError(handleError));
		return items$;
	}

	deleteFacultyRotation(item: FacultyRotationModel): Observable<FacultyRotationModel> {
		let body = JSON.stringify(item);
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		let options = { headers: headers };

		let items$ = this.http
			.delete<FacultyRotationModel>(API_URLS.API_FACULTY_ROTATION + `/${item.Id}`, options)
			.pipe(catchError(handleError));
		return items$;
	}

	checkTraineeActiveRotation(studentId: string): Observable<TraineeRotationsModel> {
		let items$ = this.http
			.get<TraineeRotationsModel>(API_URLS.API_GET_TRAINEE_ACTIVE_ROTATIONS + `/${studentId}`)
			.pipe(catchError(handleError));
		return items$;
	}
}

// this could also be a private method of the component class
function handleError(error: HttpErrorResponse) {
	// log error
	// could be something more sofisticated
	console.error(error);

	return observableThrowError(error.error);
}
